<div class="visual-import-dialog">
  <div class="header">
    <div class="d-flex align-items-center justify-content-between h-100p pl-15 pr-10">
      <div>
        <i class="fal fa-file-import fs-18"></i>
        <span class="fs-18 ml-10">Import Pivot from Legacy FITS/Optimize Pivot Studio</span>
      </div>
      <div>
        <button trgButton class="dialog-close-btn" (click)="cancel()" [disabled]="busy">
          <i class="fal fa-times i-12"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="body p-20 d-flex flex-dir-column">
    <app-spinner *ngIf="loading"></app-spinner>
    <ng-container *ngIf="!loading">
      <div class="body__header mb-20">
        <div class="d-flex align-items-center justify-content-between pb-10 border-b-dotted-1 bc-grey-1 fs-14 c-blue">
          <div>
            <span *ngIf="step == 'file'" class="bold">Upload File</span>
            <span *ngIf="step == 'unsupported-type'" class="bold">
              <i class="fas fa-exclamation-triangle c-red-2"></i>
              <span class="bold ml-4">Unsupported Chart Type</span>
            </span>
            <span *ngIf="step == 'confirm'" class="bold">Confirm Upload</span>
            <span *ngIf="step == 'duplicate-error' || step == 'confirm-replace'">
              <i class="fas fa-exclamation-triangle c-red-2"></i>
              <span class="bold ml-4">Visual Name Already Exists</span>
            </span>
          </div>
          <div *ngIf="showSteps">
            <span class="bold">Step {{((step == 'file' || step == 'unsupported-type') ? 1 : 2)}} of 2</span>       
          </div>
        </div>
      </div>
      <div class="c-grey-5" style="flex: 1 0 0">
        <div class="h-100p d-flex flex-dir-column align-items-center">
          <ng-container *ngIf="step == 'file'">
            <div class="fs-11 mb-20 text-center">
              You can use this tool to import a Pivot definition from the legacy FITS/Optimize Spend Pivot Studio.<br />
              In FITS or Optimize Spend, use the "Export" button in Pivot Studio to export the definition of a Pivot.<br />
              You can then import it into Optimize Insights here.
            </div>
            <div>
              <span class="fs-12 bold">Import Pivot:</span>
              <button trgButton color="outline" class="ml-8 h-20 lh-20 fs-10 px-6" [disabled]="busy" (click)="fileInput.click()">
                <span>Choose File</span>
                <i class="fal fa-paperclip ml-3"></i>
              </button>

              <ng-container *ngIf="fileSelected">
                <button trgButton color="grey-5" class="ml-10 h-20 lh-20 text-ellipsis w-100 fs-10 px-6" [disabled]="busy">
                  <span [title]="fileName">{{fileName}}</span>
                </button>
                <button trgButton color="grey-5" class="ml-5 h-20 lh-20 px-6 fs-10 min-w-0" [disabled]="busy" (click)="clearFile()">
                  <i class="far fa-trash-alt"></i>
                </button>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="step == 'confirm'">
            <div class="fs-11 mb-20 text-center">Please confirm the details below are correct:</div>
            <div class="fs-12 d-flex justify-content-center w-100p">
              <div class="text-right mr-5" style="flex: 0 0 50%;">
                <div>
                  <span class="bold">Visual Name:</span>
                </div>
                <div class="mt-10">
                  <span class="bold">Chart Type:</span>
                </div>
                <div class="mt-10">
                  <span class="bold">Dataset Used:</span>
                </div>
              </div>
              <div class="text-left ml-5" style="flex: 0 0 50%;">
                <div>
                  <span>{{visualName}}</span>
                </div>
                <div class="mt-10">
                  <span>{{visualType}}</span>
                </div>
                <div class="mt-10">
                  <span>{{schemaName}}</span>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="step == 'unsupported-type'">
            <div class="d-flex flex-dir-column justify-content-between h-100p">
              <div style="flex: 1 0 0">
                <div class="fs-12 d-flex justify-content-center mb-15">
                  <div class="text-right mr-5" style="flex: 0 0 50%;">
                    <div>
                      <span class="bold">Visual Name:</span>
                    </div>
                  </div>
                  <div class="text-left ml-5" style="flex: 0 0 50%;">
                    <div>
                      <span>{{visualName}}</span>
                    </div>
                  </div>
                </div>
                <div class="fs-11 text-center lh-20">
                  <span>You are attempting to import a chart type which is not supported in Insights.</span><br />
                  <span>Select Continue to proceed with the upload and import as a Pivot or Cancel to abandon.</span>
                </div>
              </div>
              <div style="flex: 0 0 0" class="d-flex align-items-center justify-content-center mb-10">
                <button trgButton color="outline" (click)="cancel()" [disabled]="busy" class="min-w-100 lh-26 h-26">
                  <span>Cancel</span>
                </button>

                <button trgButton color="primary" (click)="next()" [disabled]="busy" class="min-w-100 lh-26 h-26 ml-10">
                  <span>Continue</span>
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="step == 'duplicate-error' || step == 'confirm-replace'">
            <div class="d-flex flex-dir-column justify-content-between h-100p">
              <div style="flex: 1 0 0">
                <div class="fs-12 d-flex justify-content-center mb-15">
                  <div class="text-right mr-5" style="flex: 0 0 50%;">
                    <div>
                      <span class="bold">Visual Name:</span>
                    </div>
                  </div>
                  <div class="text-left ml-5" style="flex: 0 0 50%;">
                    <div>
                      <span>{{visualName}}</span>
                    </div>
                  </div>
                </div>
                <div class="fs-11 text-center lh-20">
                  <ng-container *ngIf="step == 'duplicate-error'">
                    <span>A Visual with the same name already exists!</span><br/>
                    <span>Do you want to proceed with the upload replacing the existing Visual or </span><br/>
                    <span>Upload this version with a suffix of {{copySuffix}}</span>
                  </ng-container>
                  <ng-container *ngIf="step == 'confirm-replace'">
                    <span>Please confirm that the existing Visual should be <strong>replaced</strong> by this upload?</span>
                  </ng-container>
                </div>
              </div>
              <div style="flex: 0 0 0" class="d-flex align-items-center justify-content-center mb-10">
                <button trgButton color="outline" (click)="cancel()" [disabled]="busy" class="min-w-100 lh-26 h-26">
                  <span>Cancel</span>
                </button>

                <button trgButton color="primary" (click)="replaceExisting()" [disabled]="busy" class="min-w-100 lh-26 h-26 ml-10">
                  <span>Replace Existing</span>
                </button>

                <button *ngIf="step == 'duplicate-error'" trgButton color="primary" (click)="createCopy()" [disabled]="busy" class="min-w-100 lh-26 h-26 ml-10">
                  <span>Suffix of {{copySuffix}}</span>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="footer px-20" *ngIf="showFooter">
    <div class="d-flex align-items-center justify-content-between h-100p">
      <div>
        <button *ngIf="step == 'confirm'" trgButton color="blue-outline" (click)="back()" [disabled]="busy" class="min-w-72">
          <span>Back</span>
        </button>
      </div>
      <div>
        <button trgButton color="blue-outline" (click)="cancel()" [disabled]="busy" class="min-w-72">
          <span>Cancel</span>
        </button>
        <button trgButton color="primary" (click)="next()" [disabled]="busy || !fileSelected" class="ml-10 min-w-72">
          <span *ngIf="step == 'file'">Next</span>
          <span *ngIf="step == 'confirm'">Confirm</span>
        </button>
      </div>
    </div>
  </div>
</div>

<input #fileInput type="file" multiple [accept]="fileContentTypes" (change)="onFileSelected()" style="display: none;" />
